// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__127Zy","content":"LayoutSettings_content__1ON5X"};